export default __webpack_public_path__ + "static/media/706.996919c9.png";